/* eslint-disable react/display-name */
/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Component } from 'react'
import {
  Button,
  Modal,
  Input,
  InputNumber,
  message,
  Select,
  Divider,
  Spin,
} from 'antd'

import styled from 'styled-components'
import { postCard95, deleteCard95 } from 'api/pgads'
import InsertHeaderDiv from './InsertHeader'
import { loadCharTypesCard95 } from '../../utils'

const { Option } = Select
export const HeaderDiv = styled.div`
  padding-bottom: 2px;
  padding-top: 2px;
  //background-color: #d3d3d37a;
`
export const HeaderTag = styled.h4`
  margin-left: 10px;
  font-weight: bold;
`
// export const ContentDiv = styled.div`
//   margin-bottom: 5px;
//   display: flex;
//   justify-content: space-around;
// `

export const ContentDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const SubDiv = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr;
  justify-self: stretch;
  grid-column-gap: 10px;
`

// const SubDiv = styled.div`
//   margin-left: 5px;
//   display: inline-grid;
// `

const AddonText = styled.div`
  position: relative;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
  display: table-cell;
  display: grid;
  align-content: center;
`
// width: -webkit-fill-available;

class Card95EditPrompt extends Component {
  state = {
    ...this.props,
    ...this.props.rowData,
    isAdminType: this.props.isAdminType || false,
    lock: this.props.rowData.lock || this.props.lock || 'U',
    loadChar:
      this.props.rowData === undefined ? '1' : this.props.rowData.loadChar,
    validation: [],
    errors: [],
  }

  save = () => {
    const {
      mode = 'N',
      targetInfo,
      grossNoGross,
      setShowEditDialog,
      setDataErrors,
    } = this.props
    const {
      utility,
      unit,
      year,
      month,
      grossMaxCap,
      grossDepCap,
      grossActGen,
      netMaxCap,
      netDepCap,
      netActGen,
      loadChar,
      attStart,
      actualStart,
      loadDesc,
      servHour,
      resHour,
      pumpHour,
      syncHour,
    } = this.state
    if (
      utility === undefined ||
      unit === undefined ||
      utility == null ||
      unit == null
    ) {
      message.error('Please, Select Unit')
      return
    }
    if (mode === 'V') {
      setDataErrors()
      setShowEditDialog(false)
      return
    }

    // this.setState({ loading: true })
    this.props.setLoading(true)

    const data = [
      {
        utility,
        unit,
        year,
        month,
        grossMaxCap,
        grossDepCap,
        grossActGen,
        netMaxCap,
        netDepCap,
        netActGen,
        loadChar,
        attStart,
        actualStart,
        loadDesc,
        servHour,
        resHour,
        pumpHour,
        syncHour,
      },
    ]
    if (mode === 'D')
      deleteCard95(targetInfo)(data).fork(
        e => this.props.setError(e, setShowEditDialog),
        data => {
          if (data.length > 0) {
            setDataErrors(data)
            this.props.setLoading(false)
          } else {
            message.info('Data deleted successfully.')
            setDataErrors()
            setShowEditDialog(false)
            // this.setState({ loading: false })
            this.props.setLoading(false)
            this.props.retrieveData({})
          }
        }
      )
    else
      postCard95(
        targetInfo,
        grossNoGross
      )(data).fork(
        e => this.props.setError(e, setShowEditDialog),
        datar => {
          if (datar.length > 0) {
            // let onlyWarning = data.every(d => d.severity == 0)
            // this.setState({
            //   loading: false,
            //   errors: data,
            //   onlyWarning,

            //   action: 'save',
            // })

            setDataErrors(datar)
            // this.setState({ loading: false })
            this.props.setLoading(false)
          } else {
            // this.setState({ loading: false })
            this.props.setLoading(false)
            setShowEditDialog(false)
            // this.props.setPromptMsg('Data saved Successfully.', false)
            message.success('Data saved Successfully.')
            setDataErrors(null)
            this.props.retrieveData({})
          }
        }
      )
  }

  handleChange = (e, { name, value }, dataModified = true) => {
    this.setState({
      [name]: value,
      dataModified: dataModified && !!this.state.utility,
    })
  }

  handleNumber = (value, name) => {
    this.handleChange(null, { name, value })
    // this.setState(() => ({
    //   [name]: value,
    // }))
  }

  setInsertData = props => {
    this.setState({ loadData: props, dataModified: false })
    this.setState(props)
  }

  clearData = _ => {
    const columns =
      this.props.grossNoGross === 'GROSS' ? grossColumns : noGrossColumns
    const data = columns
      .map(k => ({ [k]: null }))
      .reduce((a, b) => ({ ...a, ...b }))
    this.setState({ ...data, loadChar: '1' })
  }

  clearModificationData = _ => {
    this.clearData()
    this.setState({ ...(this.state.loadData || {}), dataModified: false })
  }

  render() {
    const {
      mode = 'N',
      /* rowData, */
      utilityNameMap,
      unitNameMap,
      grossNoGross,
      showEditDialog,
      setShowEditDialog,
      targetInfo,
      utilityUnitMap,
      headers,
      setMode,
    } = this.props
    const {
      grossMaxCap,
      grossDepCap,
      grossActGen,
      netMaxCap,
      netDepCap,
      netActGen,
      loadChar,
      attStart,
      actualStart,
      loadDesc,
      servHour,
      resHour,
      pumpHour,
      syncHour,
      isAdminType,
      lock,
    } = this.state

    const renderComponent = [
      {
        grossMaxCap: {
          label: 'Gross Maximum Capacity',
          comp: 'input',
          type: 'number',
          name: 'grossMaxCap',
          value: grossMaxCap,
          labeled: '(MW)',
          labelPosition: 'right',
        },
        netMaxCap: {
          label: 'Net Maximum Capacity',
          comp: 'input',
          type: 'number',
          name: 'netMaxCap',
          value: netMaxCap,
          labeled: '(MW)',
          labelPosition: 'right',
        },
        grossDepCap: {
          label: 'Gross Dependable Capacity',
          comp: 'input',
          type: 'number',
          name: 'grossDepCap',
          value: grossDepCap,
          labeled: '(MW)',
          labelPosition: 'right',
        },
        netDepCap: {
          label: 'Net Dependable Capacity',
          comp: 'input',
          type: 'number',
          name: 'netDepCap',
          value: netDepCap,
          labeled: '(MW)',
          labelPosition: 'right',
        },
        grossActGen: {
          label: 'Gross Actual Generation',
          comp: 'input',
          type: 'number',
          name: 'grossActGen',
          value: grossActGen,
          labeled: '(MWH)',
          labelPosition: 'right',
        },
        netActGen: {
          label: 'Net Actual Generation',
          comp: 'input',
          type: 'number',
          name: 'netActGen',
          value: netActGen,
          labeled: '(MWH)',
          labelPosition: 'right',
          min: false,
        },
        divider: {
          comp: 'divider',
          name: 'divider',
        },
        divider2: {
          comp: 'divider',
          name: 'divider',
        },
        attStart: {
          label: 'Attempted Starts',
          comp: 'input',
          type: 'number',
          name: 'attStart',
          value: attStart,
        },
        actualStart: {
          label: 'Actual Starts',
          comp: 'input',
          type: 'number',
          name: 'actualStart',
          value: actualStart,
        },
        loadDesc: {
          label: 'Load Description',
          comp: 'input',
          type: 'string',
          name: 'loadDesc',
          value: loadDesc,
        },
        loadChar: {
          label: 'Load Characteristics',
          comp: 'selection',
          type: 'number',
          name: 'loadChar',
          value: loadChar /* || (loadCharTypes && loadCharTypes[0].value) || '', */,
          options: this.props.loadCharTypes || loadCharTypesCard95,
          // options: Object.keys( (this.props.loadCharTypesGrid || loadCharTypesFromUnit)).map(k)
        },
        resHour: {
          label: 'Reserve Hours',
          comp: 'input',
          type: 'number',
          name: 'resHour',
          value: resHour,
        },
        servHour: {
          label: 'Service Hours',
          comp: 'input',
          type: 'number',
          name: 'servHour',
          value: servHour,
        },
        syncHour: {
          label: 'Synchronous Hours',
          comp: 'input',
          type: 'number',
          name: 'syncHour',
          value: syncHour,
        },
        pumpHour: {
          label: 'Pump Hours',
          comp: 'input',
          type: 'number',
          name: 'pumpHour',
          value: pumpHour,
        },
        nullComp: { label: '', comp: 'null' },
        '': {
          label: '',
        },
      },
    ]
    // let renderComponentGross = []
    // let renderComponentGrossArray = []
    const renderComponents = columns => {
      let renderComponentGross = []
      const renderComponentGrossArray = []
      columns.map((g, idx) =>
        renderComponent.forEach(value => {
          if (idx !== 0 && idx % 2 === 0) {
            renderComponentGrossArray.push(renderComponentGross)
            renderComponentGross = []
          }
          renderComponentGross.push(value[g])
        })
      )
      renderComponentGrossArray.push(renderComponentGross)
      renderComponentGross = []
      return renderComponentGrossArray
    }

    const renderComponentFilter =
      grossNoGross === 'GROSS'
        ? renderComponents(grossColumns)
        : renderComponents(noGrossColumns)

    const disableComp =
      mode === 'V' || mode === 'D'
        ? true
        : isAdminType && (mode === 'N' || mode === 'E' || mode === 'D')
        ? false
        : !isAdminType &&
          lock === 'L' &&
          (mode === 'E' || mode === 'N' || mode === 'D')
        ? // eslint-disable-next-line no-unneeded-ternary
          true
        : false

    const disaableButton =
      mode === 'V'
        ? false
        : isAdminType && (mode === 'N' || mode === 'E' || mode === 'D')
        ? false
        : !isAdminType &&
          lock === 'L' &&
          (mode === 'E' || mode === 'N' || mode === 'D')
        ? // eslint-disable-next-line no-unneeded-ternary
          true
        : false

    return [
      <Modal
        closable
        bodyStyle={{ padding: '0px' }}
        style={{ top: 20, zIndex: 500 }}
        key="card95"
        title={
          //    mode == 'new' ? (
          <InsertHeaderDiv
            setShowEditDialog={setShowEditDialog}
            utilityUnitMap={utilityUnitMap}
            utilityNameMap={utilityNameMap}
            unitNameMap={unitNameMap}
            handleChange={this.handleChange}
            state={this.state}
            apiTargetInfo={targetInfo}
            setInsertData={this.setInsertData}
            headers={headers}
            mode={mode}
            setMode={setMode}
            setError={this.props.setError}
            setLoading={this.props.setLoading}
            loading={this.props.spinning}
            clearData={this.clearData}
            dataModified={this.state.dataModified}
            isAdminType={isAdminType}
            lock={lock}
            disableComp={disableComp}
          />
          // ) : (
          //   HeaderDivComp()
          // )
        }
        visible={showEditDialog}
        width={1000}
        footer={
          <div>
            <Button
              type="primary"
              onClick={this.save}
              loading={this.props.spinning || false}
              disabled={!this.state.dataModified && disaableButton}
            >
              {mode === 'N'
                ? 'Insert'
                : mode === 'D'
                ? 'Delete'
                : mode === 'E'
                ? 'Save'
                : 'OK'}
            </Button>
            {(mode === 'N' || mode === 'E') && (
              <Button
                onClick={this.clearModificationData}
                disabled={!this.state.dataModified}
                loading={this.props.spinning || false}
              >
                Clear Modification
              </Button>
            )}
            {mode !== 'V' && (
              <Button
                loading={this.props.spinning || false}
                onClick={() => {
                  setShowEditDialog(false)
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        }
        onCancel={() => setShowEditDialog(false)}
        destroyOnClose
        maskClosable={false}
      >
        <Spin spinning={this.props.spinning}>
          <div
            style={{
              display: 'grid',
              gridRowGap: '5px',
              padding: '5px 20px 5px 20px',
            }}
          >
            {renderComponentFilter.map(l => (
              <ContentDiv>
                {l.map((c, i) =>
                  c.comp === 'divider' ? (
                    <Divider
                      style={{
                        margin: '0px',
                        marginTop: '10px',
                        padding: '1px',
                        backgroundColor: '#a5caf1',
                        gridColumnEnd: 'span 2',
                      }}
                    />
                  ) : (
                    c.comp && (
                      <SubDiv
                        style={{
                          marginLeft: i === 0 ? undefined : '30px',
                          // width: c.name == 'loadDesc' || c.name == 'loadChar' ? '100%' : undefined,
                          gridColumnEnd:
                            c.name === 'loadDesc' || c.name === 'loadChar'
                              ? 'span 2'
                              : undefined,
                        }}
                      >
                        <div
                          style={{ gridColumnEnd: 'span 2', fontWeight: '500' }}
                        >
                          {c.label}
                        </div>
                        {c.comp ? (
                          c.comp === 'input' ? (
                            c.type === 'string' ? (
                              <React.Fragment>
                                <Input
                                  disabled={disableComp}
                                  key={c.name}
                                  // fluid={c.name == 'loadDesc' || c.name == 'loadChar'}
                                  type={c.type}
                                  value={c.value || ''}
                                  placeholder={c.label}
                                  name={c.name}
                                  addonBefore={c.labeled}
                                  labelPosition={
                                    c.labelPosition
                                      ? c.labelPosition
                                      : undefined
                                  }
                                  onChange={e =>
                                    this.handleNumber(e.target.value, c.name)
                                  }
                                  style={{
                                    gridColumnEnd:
                                      c.name === 'loadDesc' ||
                                      c.name === 'loadChar'
                                        ? 'span 2'
                                        : undefined,
                                  }}
                                />
                                {c.labeled && (
                                  <AddonText
                                    style={{
                                      width: 'auto',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {c.labeled}
                                  </AddonText>
                                )}
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <InputNumber
                                  min={c.min === false ? undefined : 0}
                                  key={c.name}
                                  type={c.type}
                                  value={c.value || ''}
                                  placeholder={c.label}
                                  name={c.name}
                                  labelPosition={
                                    c.labelPosition
                                      ? c.labelPosition
                                      : undefined
                                  }
                                  onChange={value =>
                                    this.handleNumber(value, c.name)
                                  }
                                  style={{
                                    width: c.labeled ? 'auto' : '100%',
                                    gridColumnEnd: c.labeled
                                      ? undefined
                                      : 'span 2',
                                  }}
                                  disabled={disableComp}
                                />
                                {c.labeled && (
                                  <AddonText
                                    style={{
                                      width: 'auto',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {c.labeled}
                                  </AddonText>
                                )}
                              </React.Fragment>
                            )
                          ) : c.comp === 'selection' ? (
                            <React.Fragment>
                              <Select
                                disabled={disableComp}
                                key={c.name}
                                value={c.value || '1'}
                                id={c.name}
                                placeholder={c.label}
                                name={c.name}
                                onChange={value =>
                                  this.handleNumber(value, c.name)
                                }
                                selection
                                style={{
                                  gridTemplateColumns: '1fr',
                                  gridColumnEnd: 'span 2',
                                }}
                              >
                                {c.options.map(op => (
                                  <Option value={op.value}>{op.text}</Option>
                                ))}
                              </Select>
                              {c.labeled && <AddonText>{c.labeled}</AddonText>}
                            </React.Fragment>
                          ) : null
                        ) : null}
                      </SubDiv>
                    )
                  )
                )}
              </ContentDiv>
            ))}
          </div>
        </Spin>
      </Modal>,
    ]
  }
}

export default Card95EditPrompt

export const grossColumns = [
  'grossMaxCap',
  'netMaxCap',
  'grossDepCap',
  'netDepCap',
  'grossActGen',
  'netActGen',
  'divider',
  '',
  'attStart',
  'actualStart',
  'loadDesc',
  '',
  'loadChar',
  '',
  'divider',
  '',
  'resHour',
  'servHour',
  'syncHour',
  'pumpHour',
  'nullComp',
]
export const noGrossColumns = [
  'netMaxCap',
  'netDepCap',
  'netActGen',
  'nullComp',
  'divider',
  '',
  'attStart',
  'actualStart',
  'loadDesc',
  '',
  'loadChar',
  '',
  'divider',
  '',
  'servHour',
  'resHour',
  'pumpHour',
  'syncHour',
]
